var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"index-down"},[_c('h2',[_vm._v(_vm._s(_vm.childItem.propsValue.data.customField2))]),_c('button',[_vm._v(_vm._s(_vm.childItem.propsValue.data.customField3.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }